<template>
  <div class="videoPlayer">
    <h2 class="head1" style="text-align: center">
      {{ $t("videoPlayer.title") }}
    </h2>
    <br />
    <!--<video-embed
      :params="{ autoplay: 1 }"
      src="https://youtu.be/qhS-Mjx8ZAY"
    ></video-embed>-->
    <div class="gupshup-video">
      <iframe
        class="video-embedd"
        width="100%"
        height="400px"
        src="https://www.youtube.com/embed/tIPGlHR2wRE"
        frameborder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowfullscreen
      ></iframe>
    </div>
  </div>
</template>

<script>
import { setLocale } from "../services/firebase";
export default {
  name: "videoPlayer",
  mounted() {
    setLocale();
  },
  props: [],
};
</script>
<style lang="scss">
@media (min-width: 320px) and (max-width: 960px)  {
  .head1 {
    font-size: 25px;
    margin: 0px;
  }
  .videoPlayer {
    margin: auto;
    display: block;
  }
  .gupshup-video {
    margin: 10px;
  }
}
@media (min-width: 960px) {
  .videoPlayer {
    margin: auto;
    display: block;
  }
  .gupshup-video {
    height: "300px";
  }
}
/*
.embed-responsive-item {
  width: 100%;
  height: 400px;
}*/
</style>
